import React, { useContext, useState } from 'react'
import './paymentMethod.css'
import CreditCardForm from '../creditCardForm/CreditCardForm'
// import StandingOrderSelector from '../standingOrderSelector/StandingOrderSelector'
import ExistingPermission from '../bankInfoForm/ExistingPermission'
import BankStandingOrder from '../standingOrderSelector/BankStandingOrder'
import { registrationContex } from '../../service/RegisrationContext'
import { appContext } from '../../service/AppContext'

export default function PaymentMethod({ monthlyDonation, onCompleted }) {

    const { donor } = useContext(registrationContex);
    const { urlAgent } = useContext(appContext);

    const [mainMethod, setMainMethod] = useState('creditCard')

    return (
        <div className='payment-method'>
            <div role="heading" aria-level="2" className='heading-h3'>אמצעי תשלום</div>
            <div className='payment-value'>
                <p className='sub-header'>הסכום החודשי לחיוב</p>
                <div>
                    <h3>₪{monthlyDonation?.toLocaleString()}</h3>
                </div>
            </div>
            <label htmlFor="credit-card">
                <input type="radio" name="main-method" id="credit-card" checked={mainMethod === 'creditCard'} onChange={(e) => setMainMethod('creditCard')} />תשלום בכרטיס אשראי
            </label>
            {(mainMethod === 'creditCard') &&
                <CreditCardForm onCompleted={onCompleted} />
            }
            <hr className='card-hr hr-middle' />
            <label htmlFor="bank-standing-order">
                <input type="radio" name="main-method" id="bank-standing-order" checked={mainMethod === 'bankStandingOrder'} onChange={(e) => setMainMethod('bankStandingOrder')} />תשלום בהוראת קבע בנקאית
            </label>
            {(mainMethod === 'bankStandingOrder') &&
                <BankStandingOrder onCompleted={onCompleted} />
            }
            {(donor?.isMember && (urlAgent?.lead || urlAgent?.donor)) &&
                <>
                    <hr className='card-hr hr-middle' />
                    <label htmlFor="bank-use-existing">
                        <input type="radio" name="main-method" id="bank-use-existing" checked={mainMethod === 'useExisting'} onChange={(e) => setMainMethod('useExisting')} />שימוש בהרשאה קיימת
                    </label>
                {(mainMethod === 'useExisting') &&
                    <div className='bank-standing-order'>                    
                        <ExistingPermission onCompleted={onCompleted} />
                    </div>
                    }
                </>
            }

        </div>
    )
}
